

export default {
    name: "PortfolioKpiCostsIncomeModal",

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        selectedPortfolio: {
            type: Object,
            default: () => {},
        },
    },

    emits: ['input', 'success'],

    computed: {
        isShowDividendsTab() {
            return !this.selectedPortfolio || !this.selectedPortfolio?.isWatchList || this.selectedPortfolio?.totalCashflow > 0;
        },
        isSandboxMode() {
            return this.$store.state.preferences.isSandboxMode;
        },
        dividendsTabLink() {
            if (this.isSandboxMode) {
                return this.selectedPortfolio?.id ?
                    this.$getTranslatedRoutePath(`/sandbox/portfolio/${this.selectedPortfolio?.id}/dividends/`) :
                    this.$getTranslatedRoutePath('/sandbox/dashboard/dividends/')
            }
            return this.selectedPortfolio?.id ?
                this.$getTranslatedRoutePath(`/finance/portfolio/${this.selectedPortfolio?.id}/dividends/`) :
                this.$getTranslatedRoutePath('/finance/dashboard/dividends/')
        }
    },

    methods: {
        openWindow() {
            this.$emit('input', true)
        },
        closeWindow() {
            this.$emit('input', false)
        },
        onKeyDown(e) {
            if (e.key === 'Escape') this.closeWindow();
            if (e.key === 'Enter' && this.isVisible) {
                this.closeWindow()
            }
        },
    },
}
